export default function MaterialSymbol({ name, size = 24, fill = 0, color }) {
  return (
    <span
      className="material-symbols-rounded"
      style={{
        fontSize: size,
        color: color,
        fontVariationSettings: `"FILL" ${fill}, "wght" 400, "GRAD" 0, "opsz" ${size}`,
      }}
    >
      {name}
    </span>
  );
}
